import { TextToSubscribeButtonElement } from "@redotech/redo-model/content-builder/element-schema";
import { SUBSCRIBE_MESSAGE } from "@redotech/redo-model/signup-form";
import { createSecureSmsUri } from "@redotech/util/phone-number";
import { memo, useEffect, useState } from "react";
import { BrandKitButton } from "../../brand-kit-button";
import { FormElementProps } from "./index";

export const TextToSubscribeButton = memo(function TextToSubscribeButton({
  element,
  brandKit,
  brandKitOverrides,
  merchantPhoneNumber,
  anonymousId,
  submitting,
  isBuilder,
}: Pick<
  FormElementProps<TextToSubscribeButtonElement>,
  | "element"
  | "brandKit"
  | "brandKitOverrides"
  | "merchantPhoneNumber"
  | "anonymousId"
  | "submitting"
  | "isBuilder"
>) {
  const [shouldOpenSms, setShouldOpenSms] = useState(false);

  // This effect runs after the user click (first tap) and automatically
  // triggers the SMS (second tap) - mimicking Attentive's pattern
  useEffect(() => {
    if (shouldOpenSms && !isBuilder && merchantPhoneNumber) {
      const smsBody = anonymousId
        ? `${SUBSCRIBE_MESSAGE} ID:${anonymousId}`
        : SUBSCRIBE_MESSAGE;

      const smsUri = createSecureSmsUri({
        phoneNumbers: [merchantPhoneNumber],
        body: smsBody,
      });

      // Auto-trigger SMS from user gesture context
      if (smsUri) {
        window.location.href = smsUri;
      }
      setShouldOpenSms(false);
    }
  }, [shouldOpenSms, isBuilder, merchantPhoneNumber, anonymousId]);

  const handleClick = () => {
    if (isBuilder) {
      return;
    }
    // User's single click triggers the SMS flow
    setShouldOpenSms(true);
  };

  return (
    <BrandKitButton
      brandKit={brandKit}
      hierarchy={element.hierarchy}
      onClick={handleClick}
      override={
        brandKitOverrides.buttons.enabled
          ? brandKitOverrides.buttons
          : undefined
      }
      pending={submitting}
      text={element.text}
      type={element.action === "submit-and-advance" ? "submit" : "button"}
    />
  );
});
